import { render } from "./NewAge.vue?vue&type=template&id=683046ba&scoped=true"
import script from "./NewAge.vue?vue&type=script&lang=js"
export * from "./NewAge.vue?vue&type=script&lang=js"

import "./NewAge.vue?vue&type=style&index=0&id=683046ba&lang=scss&scoped=true"

import exportComponent from "/builds/arena/frontend/game-maplestory-landing/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-683046ba"]])

export default __exports__